// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1uDnV","tab":"Tabs_tab__33UQl","tabActive":"Tabs_tabActive__2izPQ"};